// src/modules/app-views/goodsReceipt/seed.js
// *******************************************************************************
// GOODS RECEIPT PARAMETERS SEED
// *******************************************************************************
// Seeds default warehouse for stock distribution on goods receipt items.
// Also seeds warehouse for products module (shared parameters).
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';
import { generateUidV4 } from 'utils/helpers';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const WAREHOUSE_COLORS = [
  '#ff00e1', '#2f54eb', '#52c41a', '#fa8c16', '#f5222d',
  '#722ed1', '#13c2c2', '#eb2f96', '#a0d911', '#faad14',
  '#1890ff', '#36cfc9', '#ff7a45', '#9254de', '#597ef7',
];

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedGoodsReceiptParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const productsParams = storedParameters?.modules?.products;
  const results = [];

  // Seed default warehouse if none exist (warehouses now under products module)
  const warehouseResult = await seedWarehouses({
    currentData: productsParams?.warehouses,
  });
  if (warehouseResult) results.push(warehouseResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedGoodsReceiptParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************

/**
 * Seed default warehouse if no active warehouses exist.
 * Creates "S01-Principal" as the default warehouse.
 */
async function seedWarehouses({ currentData }) {
  // Check if active warehouses already exist
  const hasActive = Array.isArray(currentData) && currentData.some(w => !w.removed);
  if (hasActive) return null;

  const randomColor = WAREHOUSE_COLORS[Math.floor(Math.random() * WAREHOUSE_COLORS.length)];

  const defaultWarehouse = [
    {
      uid: generateUidV4(),
      code: 'S01',
      name: 'Principal',
      description: 'Estoque Principal',
      color: randomColor,
      isDefault: true,
      children: [],
    },
  ];

  try {
    await appService.updateModulePreferences({
      moduleId: 'products',
      category: 'warehouses',
      data: defaultWarehouse,
    });

    return { category: 'warehouses', seeded: true, data: defaultWarehouse };
  } catch (error) {
    console.error('[seedGoodsReceiptParameters] Error seeding warehouses:', error);
    return { category: 'warehouses', seeded: false, error };
  }
}
